import type { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import React from 'react';
import { ID_LAYER_HEADER__CA__CHILDCARES } from 'Components/utils/identifiers/constants';
import { LAYER_NAME_UPSELL_CHILDCARES } from 'Components/utils/layers/layers.constants';
import { t } from 'Src/i18n';
import { ClosableLayer } from 'Components/widgets/layer/ClosableLayer';
import { StayLayerHeader } from 'Components/widgets/stay-layer-header/StayLayerHeader';
import { ChildcareLayerConnected } from './ChildcareLayer';
type Props = PropsWithPageTracking<{
  forwardRef: ReactRef;
  stay: StayEntity;
}>;
export const ChildcareLayerContainer = ({ forwardRef, stay, tracking }: Props) => {
  const title = t('stays.linkLabels.upsells.addChildcareLabel');
  return (
    <ClosableLayer
      {...asWidgetProps<ComponentProps<typeof ClosableLayer>>({
        ariaLabel: title,
        ariaLabelledby: ID_LAYER_HEADER__CA__CHILDCARES,
        externalFocusTrapRefs: [forwardRef],
        hasAnimateEnter: true,
        header: <StayLayerHeader id={ID_LAYER_HEADER__CA__CHILDCARES} stay={stay} title={title} />,
        name: LAYER_NAME_UPSELL_CHILDCARES,
        params: ['id', 'stayId'],
        tracking,
      })}
    >
      <ChildcareLayerConnected stay={stay} />
    </ClosableLayer>
  );
};
